import * as Scrivito from "scrivito";
import React from "react";
import { Button } from "reactstrap";
import { show } from "@ebay/nice-modal-react";
import { ConfirmationModal } from "components";
import { MultipleProjectsDeleteMut } from "api/mutations";
import { useProjectActions } from "stores/project";
import { useTranslate } from "hooks";
import { useProjectListContext } from "../../hooks/useProjectListContext";
import { useLanguage } from "stores/globalStore";

type DeleteProjectsButtonProps = {
  className?: string;
};

type DeletableProject = {
  id: string;
  title?: string | null;
};

export const DeleteProjectsButton = Scrivito.connect(
  ({ className }: DeleteProjectsButtonProps) => {
    const translate = useTranslate();
    const actions = useProjectActions();
    const {
      resetCallback,
      setProjectsToDelete,
      setIsSelectAll,
      refetchProjectList,
      resetUrlParams,
      currentPageNo,
      projectId,
      projects,
      projectsToDelete,
      setCurrentPageNo,
    } = useProjectListContext();

    const typedProjects = projects as DeletableProject[];
    const language = useLanguage();

    const handleProjectsDelete = () => {
      const projectsToDeleteList = typedProjects
        .filter((proj) => projectsToDelete.includes(proj.id))
        .map((proj) => ({ id: proj.id, title: proj.title ?? "" }));

      show(ConfirmationModal, {
        submitBtnText: translate("PROJECT_LIST_DELETE_PROJECTS"),
        title: translate("PROJECT_LIST_DELETE_PROJECTS"),
        alertText: translate("MULPIPLE_PROJECTS_MODAL_DELETE_WARNING_TEXT"),
        displayList: projectsToDeleteList,
        mutation: MultipleProjectsDeleteMut,
        params: { input: { ids: projectsToDelete, languageCode: language } },
      }).then(() => {
        // setTimeout is used for update projectList properly, due to DS-cache needs some time to update the data
        setTimeout(() => {
          setProjectsToDelete([]);
          setIsSelectAll(false);
          const page =
            projectsToDelete.length === typedProjects.length &&
            currentPageNo > 1
              ? String(currentPageNo - 1)
              : String(currentPageNo);

          setCurrentPageNo(Number(page));

          if (Number(page) > 1) {
            const url = new URL(window.location.href);
            url.searchParams.set("page", page);
            window.history.replaceState({}, "", url);
          }

          refetchProjectList({
            variables: {
              page,
            },
            requestPolicy: "network-only",
          });

          if (projectId && projectsToDelete.includes(projectId)) {
            resetUrlParams();
          }
          actions.clear();
          resetCallback();
        }, 2000);
      });
    };

    return (
      <div className={className}>
        <Button className="btn btn-secondary" onClick={handleProjectsDelete}>
          {translate("PROJECT_LIST_DELETE_PROJECTS")}
        </Button>
      </div>
    );
  },
);
